/***********************
 * TABLE FOR REPORTING
 * (TABLE + IMPORT PDF/XLSX)
 ************************/
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Input,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  Tooltip,
} from "reactstrap"
import PropTypes from "prop-types"

// Datatable related plugins
import { Table as AntdTable } from "antd"

//Translation
import { withTranslation } from "react-i18next"
import {
  defaultPageSizeOptions,
  downloadExcel,
  exportPDF,
  showToast,
} from "utils/general"
import AlarmFilter from "components/Filters/AlarmFilter"
import CallFilter from "components/Filters/CallFilter"

const TableReporting = props => {
  //Dropdown button state
  const [menu, setMenu] = useState(false)
  // Tooltip state for download button
  const [tooltip, setTooltip] = useState(false)
  //   Toast message
  const toastXlsxSuccess = props.t("Excel file exported succesfully!")
  const toastPdfSuccess = props.t("PDF file exported succesfully!")

  useEffect(() => {
    console.log("PROPS TableReporting:", props)
  }, [props])

  const download = option => {
    let title = props.titleExport ? props.titleExport : props.title
    if (option === "xlsx") {
      downloadExcel(title, props.xlsxHeading, props.xlsxData)
      showToast(toastXlsxSuccess, "success", 5000, "toast-bottom-left")
    }
    if (option === "pdf") {
      exportPDF(
        title,
        props.pdfHeading,
        props.pdfData,
        props.pdfDate ? props.pdfDate : false,
        props.pdfColumnStyle
      )
      showToast(toastPdfSuccess, "success", 5000, "toast-bottom-left")
    }
  }

  return (
    <>
      <div>
        <Row className=" mt-2 mb-2">
          <div className="d-flex flex-wrap">
            <span>
              <h5 className="mt-1">{props.title}</h5>
            </span>
          </div>
        </Row>
        <Card className="mt-2">
          <CardBody>
            <Row>
              <Col className="col-12">
                {/*  */}
                <Row className="mb-1 d-flex align-items-center">
                  {/* Filter */}
                  {props.filter && (
                    <Col
                      xs="auto"
                      style={{ width: "490px" }}
                      className="order-3 order-md-1 mb-1"
                    >
                      {props.filter === "calls" ? (
                        <CallFilter
                          data={props.origSeries}
                          setFilteredEntries={props.setSeries}
                        ></CallFilter>
                      ) : (
                        <AlarmFilter
                          data={props.origSeries}
                          setFilteredEntries={props.setSeries}
                        ></AlarmFilter>
                      )}
                    </Col>
                  )}

                  {/* Found results */}
                  <Col className="col-auto order-1 order-md-2">
                    <div className="mt-2">
                      <p>
                        {props.seriesFiltered.length} {props.t("found results")}
                      </p>
                    </div>
                  </Col>

                  {/* Search */}
                  {!props.noSearch && (
                    <Col lg="auto" className="order-4 order-lg-3 ms-lg-auto">
                      <Form className="d-flex align-items-center">
                        <div className="search-box mb-2">
                          <div className="position-relative">
                            <Input
                              type="text"
                              onChange={event => props.handleSearch(event)}
                              placeholder={""}
                            />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Form>
                    </Col>
                  )}

                  {/* Export */}
                  <Col className="col-auto order-2 order-md-3 order-lg-4 ms-auto ms-lg-0">
                    <span id="dropdownBtn">
                      <Tooltip
                        placement="bottom"
                        isOpen={tooltip}
                        target="dropdownBtn"
                        toggle={() => {
                          setTooltip(!tooltip)
                        }}
                      >
                        {props.t("Download statistics")}
                      </Tooltip>
                      <Dropdown
                        isOpen={menu}
                        className="download-btn text-center mb-2"
                        type="button"
                        toggle={() => setMenu(!menu)}
                      >
                        <DropdownToggle
                          id="dropdown"
                          className="text-muted"
                          tag="i"
                        >
                          <i className="mdi mdi-download" />
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => download("xlsx")}>
                            {props.t("Download .xlsx")}
                          </DropdownItem>
                          <DropdownItem onClick={() => download("pdf")}>
                            {props.t("Download .pdf")}
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </span>
                  </Col>
                </Row>
                {/*  */}
                <div className="extra-padding">
                  <AntdTable
                    className="clear-header"
                    bordered={true}
                    size="middle"
                    rowKey={"id"}
                    loading={props.loading}
                    columns={props.columns}
                    dataSource={props.seriesFiltered}
                    expandable={props.expandable}
                    defaultSorted={props.defaultSorted}
                    rowHoverable={props.hover}
                    pagination={{
                      showSizeChanger: true,
                      defaultPageSize: 50,
                      pageSizeOptions: defaultPageSizeOptions,
                    }}
                    scroll={{
                      x: "max-content",
                      y: "70vh",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  )
}

TableReporting.propTypes = {
  t: PropTypes.any,
  handleSearch: PropTypes.func,
  seriesFiltered: PropTypes.any,
  columns: PropTypes.any,
  pdfData: PropTypes.any,
  pdfHeading: PropTypes.any,
  xlsxData: PropTypes.any,
  xlsxHeading: PropTypes.any,
  pdfDate: PropTypes.bool,
  pdfColumnStyle: PropTypes.any,
  title: PropTypes.any,
  filter: PropTypes.any,
  origSeries: PropTypes.any,
  setSeries: PropTypes.any,
  loading: PropTypes.any,
  defaultSorted: PropTypes.any,
  titleExport: PropTypes.any,
  expandable: PropTypes.any,
  hover: PropTypes.any,
  noSearch: PropTypes.any,
}

export default withTranslation()(TableReporting)
